import EastRoundedIcon from "@mui/icons-material/EastRounded";
import KeyboardArrowDownRoundedIcon from "@mui/icons-material/KeyboardArrowDownRounded";
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Box,
  Divider,
  Grid,
  Typography,
} from "@mui/material";
import pluralize from "pluralize";
import { useEffect, useState } from "react";
import useAPI from "../../../../api/hooks/useAPI";
import useColors from "../../../../api/hooks/useColors";
import ChipColor from "../../../remediation/plan/components/ChipColor";
import DetectionLabelIcon from "./DetectionLabelIcon";

const DetectionsAccordion = ({
  detections,
  handleOnClick,
  source,
  assetAffectedByDetection,
}) => {
  const colors = useColors();
  const [expanded, setExpanded] = useState(false);
  const { trackEvent } = useAPI();

  useEffect(() => {
    trackEvent("user viewed detections accordion for " + source);
  }, []);

  const handleChange = () => {
    setExpanded((prevExpanded) => !prevExpanded);
    trackEvent("user clicked on detections accordion");
  };
  const maxSeverity = detections.length
    ? Math.max(...detections.map((detection) => detection.severity))
    : 0;

  return (
    <Grid container>
      <Grid item xs={12}>
        <Box>
          <Accordion
            expanded={expanded}
            onChange={handleChange}
            sx={{
              boxShadow: " 0px 0px 2px 0px " + colors.error_dark,
              background: colors.detections_bg,
              margin: "0px 2px",
            }}
            style={{ borderRadius: "8px", padding: "16px" }}
          >
            <AccordionSummary
              expandIcon={<KeyboardArrowDownRoundedIcon />}
              style={{
                minHeight: "24px",
                height: "26px",
                padding: "0px",
              }}
            >
              <Box
                sx={{
                  display: "flex",
                  flexDirection: "row",
                  alignItems: "center",
                  gap: 1,
                }}
              >
                <DetectionLabelIcon />

                <Typography
                  variant="subtitle1"
                  style={{ minHeight: "24px", height: "26px", padding: "0px" }}
                >
                  Active Events Detected
                </Typography>
              </Box>
            </AccordionSummary>
            <Divider
              orientation="horizontal"
              flexItem
              style={{ marginTop: "10px" }}
            />
            <AccordionDetails sx={{ padding: 0 }}>
              <Box
                sx={{ display: "flex", flexDirection: "column", pt: 2, gap: 1 }}
              >
                <Box
                  sx={{
                    display: "flex",
                    flexDirection: "column",
                  }}
                >
                  <Typography variant="caption">
                    {detections?.length +
                      " " +
                      pluralize("Active event", detections?.length)}{" "}
                    detected related to this {source}.
                  </Typography>

                  {assetAffectedByDetection?.length > 0 && (
                    <Typography variant="caption">
                      At least one of them involves your critical{" "}
                      {pluralize("asset", assetAffectedByDetection.length)}:{" "}
                      {assetAffectedByDetection.map((asset, index) =>
                        index < assetAffectedByDetection.length - 1
                          ? " " + asset.name + " and"
                          : " " + asset.name
                      )}
                    </Typography>
                  )}
                </Box>
                <Box
                  sx={{
                    display: "flex",
                    gap: 1,
                  }}
                >
                  <Typography variant="caption">Highest Severity:</Typography>
                  <ChipColor
                    value={maxSeverity}
                    type={"controlPriority"}
                    size="small"
                    labelWidth={true}
                  />
                </Box>
                <Box
                  sx={{
                    display: "flex",
                    flexDirection: "row",
                    gap: "8px",
                    alignItems: "center",
                    color: colors.primary_main,
                    cursor: "pointer",
                  }}
                  onClick={handleOnClick}
                >
                  <Typography variant="overline">
                    View Related Events
                  </Typography>
                  <EastRoundedIcon sx={{ width: "18px" }} />
                </Box>
              </Box>
            </AccordionDetails>
          </Accordion>
        </Box>
      </Grid>
    </Grid>
  );
};

export default DetectionsAccordion;
